import React from "react";
import { useTranslation } from "react-i18next";

export default function Pen(props) {
  const { t } = useTranslation();
  return (
    // <li onClick={!props.hideButton && props.onClick}>
    <li onClick={!props.hideButton ? props.onClick : undefined}>
      <span
        className={`button normal-btn zoom-reset ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "zoom-reset" ? "active" : ""
        }${props.hideButton ? "passive" : ""}`}
        title={t("Reset Zoom") + " (0)"}
      >
        <img
          src={require("../../assets/img/svg/toolbar-zoom-normal.svg")}
          alt={t("Reset Zoom") + " (0)"}
        />
        {props.shouldShowButtonLabels && <span className="show-label-text">{t("Reset")}</span>}
      </span>
    </li>
  );
}
